import React from 'react'
import { HiChevronUp, HiChevronDown } from 'react-icons/hi2'
import type { SortConfig } from '../hooks/useSortableTable'

interface SortableHeaderProps {
  label: string
  sortKey: string
  currentSort: SortConfig | null
  onSort: (key: string) => void
  className?: string
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  sortKey,
  currentSort,
  onSort,
  className = ''
}) => {
  const isActive = currentSort?.key === sortKey
  const direction = currentSort?.direction

  return (
    <th
      className={`px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-neutral-600 transition-colors select-none ${className}`}
      onClick={() => onSort(sortKey)}
      title={`Ordenar por ${label}`}
    >
      <div className="flex items-center gap-2">
        <span>{label}</span>
        <div className="flex flex-col">
          <HiChevronUp 
            className={`w-3 h-3 -mb-0.5 transition-colors ${
              isActive && direction === 'asc' 
                ? 'text-blue-600 dark:text-blue-400' 
                : 'text-gray-300 dark:text-gray-600'
            }`} 
          />
          <HiChevronDown 
            className={`w-3 h-3 transition-colors ${
              isActive && direction === 'desc' 
                ? 'text-blue-600 dark:text-blue-400' 
                : 'text-gray-300 dark:text-gray-600'
            }`} 
          />
        </div>
      </div>
    </th>
  )
}

